import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';
import { CartItemButton } from 'pages/cart/cart-item/styles';
import SectionHeading from 'pages/cart/section-heading';

export const UpsellCarouselWrapper = styled.div`
  margin: 0 0 1rem 1rem;
  ${SectionHeading} {
    font: ${brandFont.headerThree};
    margin: 1.5rem 0 0.5rem 0;
  }
  ${Styles.desktop`
    ${CartItemButton} {
      box-shadow: none;
    }
  `}
`;
